import { render, staticRenderFns } from "./baobiaotj.vue?vue&type=template&id=df4e5d3c&scoped=true"
import script from "./baobiaotj.vue?vue&type=script&lang=js"
export * from "./baobiaotj.vue?vue&type=script&lang=js"
import style0 from "./baobiaotj.vue?vue&type=style&index=0&id=df4e5d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4e5d3c",
  null
  
)

export default component.exports